module.exports = __webpack_public_path__ + "static/img/teaser_03.207de48b.png";